import { normalizeRoleSlug } from "../../../public/utils/roleAccess";
import { CHEQUE_ISSUES_SUBMODULE_SLUG } from "./chequePermissionSlugs";

function permRow(permMap, slug) {
  const row = permMap?.[slug];
  return row && typeof row === "object" ? row : {};
}

function submodulePerm(permMap, slug, type) {
  if (!permMap || !slug) return false;
  const row = permMap[slug];
  if (!row || typeof row !== "object") return false;
  return Boolean(row[type]);
}

/** Cheque issues workspace — User builder `cheque-issues` row. */
function chequeIssuesStylePerms(row) {
  const canView = Boolean(row.view);
  const canCreate = Boolean(row.create);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  return {
    canView: canView || canCreate,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canView && canEdit,
    canDeleteMasters: canDelete,
    canExport: canView,
    isAdmin: canDelete,
  };
}

/**
 * Permissions for one cheque screen (User builder submodule row).
 * All roles — including admin — follow User builder only.
 */
export function buildChequePermissionsForScreen(
  permMap = {},
  _roleSlug = "",
  screenSlug = "",
) {
  const slug = normalizeRoleSlug(screenSlug);

  if (slug === CHEQUE_ISSUES_SUBMODULE_SLUG) {
    return chequeIssuesStylePerms(permRow(permMap, slug));
  }

  return buildChequePermissions(permMap);
}

export function buildChequePermissions(permMap = {}) {
  const row = permRow(permMap, CHEQUE_ISSUES_SUBMODULE_SLUG);
  return chequeIssuesStylePerms(row);
}

export function submoduleHasChequeView(permMap = {}) {
  return submodulePerm(permMap, CHEQUE_ISSUES_SUBMODULE_SLUG, "view");
}
